import axios from "axios";
import { useQuery } from "react-query";
import { API_ENDPOINT } from "../../../../../constants/constants";
import { getDbHeader } from "../utils/utils";
const useProductCategories = () => {
  return useQuery({
    queryKey: ["get-product-categories"],
    queryFn: async () => {
      const response = await axios.get(
        `${API_ENDPOINT}event/get-product-categories`,
        getDbHeader()
      );
      return response.data;
    },

    retry: (failureCount, error) => {
      if (!error.response) return true; // Retry on network errors
      const status = error.response.status;
      return status !== 401 && status !== 404 && status !== 500; // No retries for 404/500
    },
  });
};

export default useProductCategories;
